import { createFileRoute } from '@tanstack/react-router';

import { IntegrationsPage } from '@/features/integrations/integrations-page';

export const Route = createFileRoute('/_app/org/$orgId/integrations')({ component: OrgRoute });

function OrgRoute() {
  const { orgId } = Route.useParams();
  return <IntegrationsPage orgId={orgId} />;
}
